const AiContentMarketingCta = () => {
  return (
    <>
      <div className="ai-wt-cta-area">
        <div className="container">
          <div className="wt-cta-wrapper ptb-60 text-center rounded-3">
            <div className="row justify-content-center">
              <div className="col-xl-6">
                <div className="p-2">
                  <h2 className="aiwt-title text-white ff-risk-pri fs-36 mb-20">
                    Are You Prepared to Dive into <br /> Angel List Relay?
                  </h2>
                  <p className="text-white mb-20">
                    Streamline your video creation process by embedding your
                    videos into.
                  </p>
                  <a
                    href="/ai-content-marketing"
                    className="btn bg-white rounded-5 text-black fs-16 d-inline-flex align-items-center gap-3 border-0"
                  >
                    <div className="wt-cta-icon ai-wt-gd-bg-2 d-flex align-items-center justify-content-center rounded-circle p-1">
                      <svg
                        width="14"
                        height="11"
                        viewBox="0 0 14 11"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M0.445754 9.59827C0.445754 9.59827 6.95417 5.14367 12.8241 1.1261M12.8241 1.1261C8.58368 4.02837 4.97692 0.437985 4.97692 0.437985M12.8241 1.1261C8.58368 4.02837 10.625 8.69019 10.625 8.69019"
                          stroke="white"
                          strokeWidth="1.2"
                        />
                      </svg>
                    </div>
                    Request a Trial
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default AiContentMarketingCta;
